const config = {
  apiHost: process.env.REACT_APP_API_HOST,
  appEnv: process.env.REACT_APP_ENV,
  commitRef: (process.env.REACT_APP_COMMIT_REF || "HEAD").slice(0, 6),
  sentryDsn: process.env.REACT_APP_SENTRY_DSN,
  redashUrl: process.env.REACT_APP_REDASH_URL,
  streamApiKey: process.env.REACT_APP_STREAM_API_KEY,
  aiMainframeHost: process.env.REACT_APP_AI_MAINFRAME_HOST,
  portalHost: process.env.REACT_APP_BOOMSCREEN_PORTAL_URL
};

export default config;
